// Components==============
import ControlBar from 'components/Layout/ControlBar/ControlBar';
import ExerciseBottom from 'components/UI/ExerciseBottom/ExerciseBottom';
import ExerciseWrapper from 'components/UI/ExerciseWrapper/ExerciseWrapper';
import React, { createContext, useContext, useEffect, useState } from 'react';
import { AudioExerciseContext } from 'screens/AudioExercise/AudioExercise';
import shuffleArray from 'utilities/shuffleArray';
import { useHomeworkNavigation } from 'utilities/useHomeworkNavigation';
import Option from './components/Option/Option';
import './FindWrongExercise.module.scss';
// =========================

type FindWrongContextTypes = {
    current: number;
    setCurrent: React.Dispatch<React.SetStateAction<number>>;
    userCanChoose: boolean;
    setUserCanChoose: React.Dispatch<React.SetStateAction<boolean>>;
    setUserAnswers: React.Dispatch<React.SetStateAction<string[]>>;
    setPlayButtonsClicked: React.Dispatch<React.SetStateAction<number>>;
    currentAudio: string;
    setCurrentAudio: React.Dispatch<React.SetStateAction<string>>;
    wrongAnswer: any;
};

export const FindWrongContext = createContext({} as FindWrongContextTypes);

const optionTiles = Array.from(Array(4).keys());

export default function FindWrongExercise() {
    const { exercise, isFinished, setIsFinished, setProgress } = useContext(
        AudioExerciseContext
    );

    const [userAnswers, setUserAnswers] = useState<string[]>([]);
    const { current, setCurrent, next } = useHomeworkNavigation(userAnswers);
    const [currentAudio, setCurrentAudio] = useState('');

    const [wrongAnswer, setWrongAnswer] = useState<any>(null);
    const [fillerArray, setFillerArray] = useState<any>([]);
    const [options, setOptions] = useState<any[]>([]);
    const [userCanChoose, setUserCanChoose] = useState(false);

    const [playButtonsClicked, setPlayButtonsClicked] = useState(0);

    // Display data logic

    useEffect(() => {
        // @ts-ignore
        const wrongItems = Object.entries(exercise?.wrong).filter(
            (entrie: any) => entrie?.[1]?.length
        ) as any;

        // @ts-ignore
        const fillerItems = Object.entries(exercise?.filler).filter(
            (entrie: any) => entrie?.[1]?.length
        ) as any;

        shuffleArray(wrongItems);
        shuffleArray(fillerItems);

        const fillerItem = fillerItems.find(
            (items: any) => items[0] !== wrongItems[0][0]
        )[1];

        const wrongItem = wrongItems[0][1];

        shuffleArray(wrongItem);
        shuffleArray(fillerItem);

        setWrongAnswer(wrongItem[0]);
        setFillerArray(fillerItem.slice(0, 3));
    }, [current]);

    useEffect(() => {
        if (!wrongAnswer) return;
        const combinedArray = [...fillerArray, wrongAnswer];
        shuffleArray(combinedArray);

        setOptions(combinedArray);
    }, [wrongAnswer, fillerArray]);

    // Game logic

    useEffect(() => {
        if (playButtonsClicked === 4) setUserCanChoose(true);
    }, [playButtonsClicked]);

    const exerciseLength = 8;

    useEffect(() => {
        setPlayButtonsClicked(0);
        setUserCanChoose(false);
        setCurrentAudio('');

        if (current === exerciseLength) setIsFinished(true);
    }, [current]);

    useEffect(
        () => setProgress({ total: exerciseLength, done: userAnswers?.length }),
        [userAnswers?.length]
    );

    function handlePlayClick() {
        setCurrentAudio(options[0]?.name);
        setTimeout(() => {
            setCurrentAudio(options[1]?.name);
        }, 1500);
        setTimeout(() => {
            setCurrentAudio(options[2]?.name);
        }, 3000);
        setTimeout(() => {
            setCurrentAudio(options[3]?.name);
        }, 4500);
        setTimeout(() => {
            setUserCanChoose(true);
        }, 6000);
    }

    return (
        <FindWrongContext.Provider
            value={{
                current,
                setCurrent,
                userCanChoose,
                setUserCanChoose,
                setUserAnswers,
                setPlayButtonsClicked,
                currentAudio,
                setCurrentAudio,
                wrongAnswer,
            }}
        >
            <ExerciseWrapper padding="2em 1.5em">
                {!isFinished && (
                    <div styleName="options">
                        {optionTiles.map((e, index: number) => (
                            <Option
                                key={e}
                                isCorrect={
                                    options?.[index]?.name === wrongAnswer?.name
                                }
                                option={options?.[index]}
                            />
                        ))}
                    </div>
                )}
            </ExerciseWrapper>
            <ExerciseBottom
                controlBar={
                    <>
                        {!isFinished && (
                            <ControlBar
                                exerciseStatus={
                                    userAnswers.length === exerciseLength
                                        ? 'finished'
                                        : 'started'
                                }
                                next={next}
                                handlePlayClick={handlePlayClick}
                            />
                        )}
                    </>
                }
            />
        </FindWrongContext.Provider>
    );
}
